import { getDate } from "@domains/utils/reportDates";
export var SalesHolidayListMapper = function (data) {
    var datesArray = [];
    if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
        data.map(function (dateObj) {
            datesArray.push(getDate(dateObj.onDate));
        });
    }
    return datesArray;
};
